module.exports = __webpack_public_path__ + "static/media/adashi.24bee955.png";